import { CABINET_ROUTES } from "../../cabinetDashboard/routePaths";

export function getDoctorRedirectTarget(state) {
  const redirect = state?.redirectTo || state?.from;
  const redirectString = typeof redirect === "string" ? redirect : null;
  const pathname = redirectString || redirect?.pathname;
  const pathOnly = typeof pathname === "string" ? pathname.split(/[?#]/, 1)[0] : "";
  const normalizedPath = pathOnly.replace(/\/+$/, "").toLowerCase();

  if (
    typeof pathname !== "string" ||
    !pathname.startsWith("/") ||
    pathname.startsWith("//") ||
    ["/logindoctor", "/verifcode"].includes(normalizedPath)
  ) {
    return CABINET_ROUTES.DASHBOARD;
  }

  if (redirectString) return redirectString;
  return `${pathname}${redirect.search || ""}${redirect.hash || ""}`;
}

export default getDoctorRedirectTarget;
